export default {
  name: 'ConfirmedScreen',
  props: {
    fromApp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};